import { $amplitudeExperimentsAtom } from '@client/core/atoms/amplitude.js';
import { $config } from '@client/core/atoms/config.js';
import {
  DeviceType,
  ExperimentVariants,
  type SizeMediaType
} from '@schibsted-nmp/advertising-shared';

export const getExperimentMediaTypes = (mediaTypes: SizeMediaType[]) => {
  if (typeof window === 'undefined' || !isExperimentViewportSize())
    return mediaTypes;

  const { experiments } = $amplitudeExperimentsAtom.get();
  const variant = experiments['advt-small-mobile-screen-tori'];

  if (!variant || variant === ExperimentVariants.Control) {
    return mediaTypes;
  }

  // 16px - page container padding from the side
  const viewportWidth = window.innerWidth - 16;
  // 50px - header height
  const viewportHeight = window.innerHeight - 50;

  return mediaTypes.filter((mediaType) => {
    return (
      !mediaType.width ||
      !mediaType.height ||
      (mediaType.width <= viewportWidth && mediaType.height <= viewportHeight)
    );
  });
};

export const isExperimentViewportSize = () => {
  if (typeof window === 'undefined') return false;

  const config = $config.get();

  if (config?.deviceType !== DeviceType.Mobile) return false;

  const width = window.innerWidth;
  const height = window.innerHeight;

  return width < 316 && height <= 650;
};
